import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";

import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Location = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        width: "100%",
        maxWidth: "100%"
      }}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Category Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/categorytable' }}
                permissions={permissions}
                title="Category Master"
              />
            )}

            {hasModulePermission("Group Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/grptable' }}
                permissions={permissions}
                title="Group Master"
              />
            )}

            {hasModulePermission("SubGroup Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/subgrptable' }}
                permissions={permissions}
                title="SubGroup Master"
              />
            )}

            {hasModulePermission("Assets/Store Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/assettable' }}
                permissions={permissions}
                title="Assets/Store Master"

              />
            )}

            {hasModulePermission("Unit Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/unittable' }}
                permissions={permissions}
                title="Unit Master"
              />
            )}

            {hasModulePermission("Checkin Article Category") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/articlecategorytable' }}
                permissions={permissions}
                title="Checkin Article Category"
              />
            )}

            {hasModulePermission("Checkin Article") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/articletable' }}
                permissions={permissions}
                title="Checkin Article"
              />
            )}
             {hasModulePermission("Checkin Article Configuration") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/chkin-article-config-table' }}
                permissions={permissions}
                title="Checkin Article Configuration"
              />
             )}  

          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Location;